import { EnumBase } from 'hay-core-react';
class UfEnum extends EnumBase {
    constructor() {
        super(
            [
                'main.contrato.uf.AC', 'main.contrato.uf.AL', 'main.contrato.uf.AP', 'main.contrato.uf.AM',
                'main.contrato.uf.BA', 'main.contrato.uf.CE', 'main.contrato.uf.DF', 'main.contrato.uf.ES',
                'main.contrato.uf.GO', 'main.contrato.uf.MA', 'main.contrato.uf.MT', 'main.contrato.uf.MS',
                'main.contrato.uf.MG', 'main.contrato.uf.PA', 'main.contrato.uf.PB', 'main.contrato.uf.PR',
                'main.contrato.uf.PE', 'main.contrato.uf.PI', 'main.contrato.uf.RJ', 'main.contrato.uf.RN',
                'main.contrato.uf.RS', 'main.contrato.uf.RO', 'main.contrato.uf.RR', 'main.contrato.uf.SC',
                'main.contrato.uf.SP', 'main.contrato.uf.SE', 'main.contrato.uf.TO',
            ],
            'main.contrato.uf.SP'
        );
    }
}

const instance = new UfEnum();
export default instance;
